import { TransportDetailsModule } from './../../../common/components/transport-details/transport-details.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionTabletTransportItemComponent } from './action-tablet-transport-item/action-tablet-transport-item.component';
import { CommonLayoutModule, CommonUIModule } from '@sdbn/common';
import { MatRippleModule } from '@angular/material/core';
import { ActionTabletModule } from '@sdbn/common';



@NgModule({
  declarations: [
    ActionTabletTransportItemComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIModule,
    ActionTabletModule,
    TransportDetailsModule,
    MatRippleModule
  ]
})
export class ActionTabletTransportModule { }
